import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_STARTER_EXPERIENCE_DASHBOARD_START_STRONG = defineFcm('starter_experience_dashboard_start_strong')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experimentName: { type: 'string' },
				enabled: { type: 'boolean' },
				// optional so existing stored values (predating this field) still normalize instead of
				// falling back to `.withDefault()` wholesale — which would also reset `enabled: false` and
				// silently disable Start Strong in production.
				startStrongOnboardingVariant: { type: 'boolean', optional: true },
			},
		}),
	)
	.withDefault({
		experimentName: 'starter_experience_start_strong',
		enabled: false,
		startStrongOnboardingVariant: false,
	})
	.withMerger(({ countryValue, localeValue }) => ({
		...countryValue,
		...localeValue,
		enabled: countryValue.enabled && localeValue.enabled,
		// Missing on either scope (an existing stored value predating this field) must resolve to
		// false, not `undefined` — same reasoning as the shape being optional above.
		startStrongOnboardingVariant:
			localeValue.startStrongOnboardingVariant ?? countryValue.startStrongOnboardingVariant ?? false,
	}))
	.toConfig({
		owner: 'squad-axolotl',
		scope: 'corgi-front-end',
		context: 'Starter Dashboard',
		description:
			'Controls the visibility of the Start Strong guided flow on the starter dashboard — a full-screen, step-by-step experience that walks petition starters through a few early tasks on their first day to set them up for success. ' +
			'startStrongOnboardingVariant is a temporary rollout flag, shared with petition_service, that additionally gates starter_experience_start_strong_after_sap (the petition-creation-onboarding reframe): it keeps that experiment from bucketing users even while `enabled` is on. Remove once that rollout is complete.',
		mergeLogic: 'Checks both country and locale; both must be enabled for the experience to be enabled.',
		template: {
			experimentName: 'starter_experience_start_strong',
			enabled: false,
			startStrongOnboardingVariant: false,
		},
	});
